import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import { getAllArticles } from '../../redux/api/blog';
import ActionButton from './ActionButton';
import ArticleCard from './ArticleCard';
import InputIcon from '../../shared/common/InputIcon';
import NoResultsFound from '../../shared/common/NoResultsFound';

const TabArticles = props => {
    const { user } = props;

    // STATE
    const [search, setSearch] = useState('');
    const [articles, setArticles] = useState([]);
    const [articlesFiltered, setArticlesFiltered] = useState([])


    // EFFECTS

    useEffect(() => {
        if (articles.length === 0) {
            getArticles(user.id);
        }
    }, []);

    useEffect(() => {
        if (search.length !== 0) {
            console.log('searchArticles')
            searchArticles(articles, search)
        } else {
            getArticles(user.id);
        }
    }, [search]);

    // FUNCTIONS

    const getArticles = async (id) => {
        let req = await getAllArticles(id);
        console.log('req', req.data);
        if (!!req) {
            setArticles(req.data);
        }
        // if(req.error){
        // 	alert("Ocurrió un error")
        // }else{
        // 	setArticles(req)
        // }
    };

    function handleSearch(e) {
        setSearch(e.target.value);
    }


    const searchArticles = (array, search) => {
		let newArray = []
		array.forEach(item => {
			if( item.attributes?.title?.toLowerCase().includes(search.toLowerCase()) 
			){ 
				newArray.push(item)
			}
		}
	);
    setArticlesFiltered(newArray.length === 0 ? [] : newArray)
	}


    // const aDeletedArticle =  async () => {
    //     console.log('getArticles(user.id)')
    //     await getArticles(user.id);
    // }

    return (
        <>
            <HeaderWrapper>
                <InputIcon value={search} onChange={handleSearch} />
                <ActionButton title="Añadir Artículo" action="/newpost" icon={<AddRoundedIcon />} bgc="var(--primary-one)" textColor="#ffff" />
            </HeaderWrapper>
            {
                search.length === 0
                ?   ( articles.length === 0 
                    ?   ( <NoResultsFound message="No existe contenido del blog, añade un artículo." /> ) 
                    :   (
                            <GridValues>
                                { articles.map(value => value.id !== undefined &&
                                    <ArticleCard value={value.attributes} key={value.id} artId={value.id} />)
                                }
                            </GridValues>
                        )
                    )
                :   ( articlesFiltered.length === 0
                    ?   ( <NoResultsFound message="No se encuentran resultados para tu búsqueda" /> ) 
                    :   (
                            <GridValues>
                                { articlesFiltered.map(value => value.id !== undefined &&
                                    <ArticleCard 
                                    value={value.attributes} 
                                    key={value.id} 
                                    artId={value.id}
                                    // aDeletedArticle={aDeletedArticle}
                                    />)
                                }
                            </GridValues>
                        )
                    )
            }
        </>
    );
};

export default TabArticles;

const GridValues = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    width: calc(100% - 8rem);
    padding: 1rem  4rem;
    height: auto;
    grid-gap: 1.5rem;
    justify-content: center;
    align-items: flex-start;
    justify-items: center;
    align-content: stretch;
    @media screen and (max-width: 425px) {
        display: flex;
        flex-direction: column;
        column-gap: 1rem;
    }
`;

const HeaderWrapper = styled.div`
    display: flex;
    flex-direction: row;
    width: calc(100% - 8rem);
    padding: 1rem  4rem;
    gap: 1rem;
    align-items: center;
    column-gap: 1.5rem;
`;
